import { find, get } from 'lodash'

const isEnrolledToExperience = (user = {}, experience = {}) => find(get(experience, 'enrollees', []), { id: get(user, 'id') })

export default isEnrolledToExperience